import React from 'react';

const Loader = () => {
    return (
        <div className='loader-wrapper'>
            <div class="loading"></div>
        </div>
    );
}

export default Loader;
